module.exports = __webpack_public_path__ + "img/beginners-series_16x9_poster.f72ab04.jpg";